import React from 'react';
import { Link } from 'react-router-dom';

const ThankYouPage = () => {
  return (
    <div className="pt-20 min-h-screen bg-white flex items-center justify-center px-4">
      <section className="w-full max-w-3xl py-24 text-center">
        <h1 className="text-5xl md:text-7xl font-bold italic tracking-tighter uppercase text-gray-900 mb-8">
          Děkujeme za poptávku
        </h1>
        <p className="text-xl text-gray-600 leading-relaxed mb-10">
          Odpovíme vám během jednoho pracovního dne.
        </p>
        <Link
          to="/"
          className="inline-block px-10 py-5 bg-blue-600 text-white rounded-full font-bold uppercase tracking-widest text-xs hover:bg-blue-700 transition-colors shadow-lg shadow-blue-600/20"
        >
          Zpět na úvod
        </Link>
      </section>
    </div>
  );
};

export default ThankYouPage;